const styles = (theme) => ({
  holidayGridContainer: {
    padding: 0,
    '& $gridHead': {
      minHeight: 32,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    '& $dataGrid': {
      height: '32%',
      border: 'unset'
    }
  },
  holidayGrid: {
    margin: '6 0 60 0',
    [`&>.gridTheme-${theme.themeName}`]: {
      height: 'unset',
      border: `1px solid ${theme.AppBGColor}`,
    },
    "& .ag-theme-material": {
      borderBottom: `1px solid ${theme.AppBGColor}`,
    },
  },
  moduleContainer: {
    paddingTop: 16
  },
  mainMenu: {
    background: theme.gridBGColor,
    borderRadius: '0px 0px 4px 4px',
    width: '170px'
  },
  menuItem: {
    padding: '6px 0px',
    "&:hover": {
      background: theme.customMultiSelectColor,
    },
  },
  customPopper: {
    zIndex: 1400,
    marginTop: 0
  },
  headerMenuIconStyles: {
    padding: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  iconLabel: {
    fontSize: theme.headerTextFontSize
  }, 
  iconLayout: {
    float: 'left',
    color: theme.iconColor,
    display: 'flex',
    alignItems: 'center',
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  },
  headerIconStyles: {
    padding: '10px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer'
  }
});

export default styles;
